import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
/**
 *
 * @param props
 */
var HrComp = function (props) {
    var className = joinClasses(props.className, "scl-a-hr", !!props.active ? "scl-a-hr--active" : undefined);
    return (React.createElement("hr", { className: className, "data-content": props.title }));
};
/**
 *
 */
export var Hr = asThemeConsumer(HrComp);
